"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const __1 = require("../../..");
const Footer_1 = require("../Footer");
function FooterContactInfo({ children, heading = 'Contact Center' }) {
    const { slim } = (0, Footer_1.useFooterContext)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!slim && (0, jsx_runtime_1.jsx)("h3", { className: "usa-footer__contact-heading", children: heading }), (0, jsx_runtime_1.jsx)("address", { className: "usa-footer__address", children: (0, jsx_runtime_1.jsx)(__1.Grid.Row, { className: !slim ? 'usa-footer__contact-info' : '', gaps: true, children: slim
                        ? react_1.Children.map(children, (child, i) => {
                            if ((0, react_1.isValidElement)(child)) {
                                return (0, react_1.cloneElement)(child, {
                                    // eslint-disable-next-line react/no-array-index-key
                                    key: `contact-info-${i}`
                                });
                            }
                            return child;
                        })
                        : children }) })] }));
}
exports.default = FooterContactInfo;
